import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { CenterTeachingHallCost } from '../../../lib/types/models/center/center-teaching-hall-costs'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getCenterTeachingHallCosts(id: number, query: PaginationRequest = {}) {
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.centers.getCenterTeachingHallCosts.url, { id }),
        query
      )
    )
    .get<PaginationResponse<CenterTeachingHallCost>>()
}
